import * as React from "react";
const SvgSortMessageArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 20, viewBox: "0 0 11 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 8L5.5 12L9.5 8", stroke: "#5B5D72", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgSortMessageArrow;
